import { ToastType } from '@dcl/ui/dist/fragments/Toast';
import { IAnnouncementProps } from '../interface';

export const renderAlertStateIcon = (statusType: string) => {
  switch (statusType) {
    case 'success':
      return ToastType.SUCCESS;
    case 'error':
      return ToastType.WARNING;
    case 'warning':
      return ToastType.CAUTION;
    default:
      return ToastType.INFO;
  }
};

export function getDistinctObjects(
  announcements: IAnnouncementProps[]
): IAnnouncementProps[] {
  const distinctObjects: { [key: string]: IAnnouncementProps } = {};

  announcements.forEach((obj) => {
    // Use the id as the key to check for uniqueness
    distinctObjects[obj.id] = obj;
  });

  // Convert the object back to an array of distinct objects
  const result = Object.values(distinctObjects);

  return result;
}
